import { render, staticRenderFns } from "./Pure.vue?vue&type=template&id=18ca127f&"
import script from "./Pure.vue?vue&type=script&lang=js&"
export * from "./Pure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports